import {
  ActivityLessonVideo,
  Lesson,
  LessonType,
  InstrumentType,
} from '@fenderdigital/api-definitions/play';

interface LessonAttrs {
  activityLessonVideo: ActivityLessonVideo | null;
  id: string;
  type: LessonType;
  instrument: InstrumentType;
}

export function getLessonAttrs(lesson: Lesson): LessonAttrs {
  const { id, type, instrument } = lesson || {};
  const activityLessonVideo = lesson?.['activity-lesson-video'] ?? null;
  const lessonType = type || 'lesson';
  const lessonInstrument = instrument || 'guitar';
  return {
    activityLessonVideo,
    id,
    type: lessonType,
    instrument: lessonInstrument,
  };
}

/**
 * Checks if the thumbnail string has a new the new video encoding
 * signature. Basically, it checks for `.{count}` vs `-{count}`.
 *
 * @param {String} thumbnail
 * @return {Boolean}
 */
export function isNewVideoEncoding(thumbnail: string): boolean {
  return thumbnail.includes('.{count}');
}

interface ThumbnailConfig {
  interval: number;
  rate: number;
  padding: string;
}

/**
 * It returns thumbnail config options to pass to flowplayer for its
 * `configuration.thumbnails` object. This also, checks for new video encoding format.
 *
 * @param {String} thumbnail
 * @param {Number} duration
 * @return {Object} returns an object with interval, rate and padding properties.
 */
export function getThumbnailConfig(thumbnail: string, duration: number): ThumbnailConfig {
  let interval = 5;
  if (isNewVideoEncoding(thumbnail)) {
    interval = 6;
    return {
      interval,
      rate: Math.round(duration / interval),
      padding: '0000000',
    };
  }
  return {
    interval,
    rate: Math.round(duration / interval),
    padding: '00000',
  };
}
